export const InvitationStatus = {
  PENDING: "pending",
  REJECTED: "rejected",
  ACCEPTED: "accepted",
} as const
